import { render, staticRenderFns } from "./BalanceTransDetails.vue?vue&type=template&id=7e07a8e4&scoped=true"
import script from "./BalanceTransDetails.vue?vue&type=script&lang=js"
export * from "./BalanceTransDetails.vue?vue&type=script&lang=js"
import style0 from "./BalanceTransDetails.vue?vue&type=style&index=0&id=7e07a8e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e07a8e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e07a8e4')) {
      api.createRecord('7e07a8e4', component.options)
    } else {
      api.reload('7e07a8e4', component.options)
    }
    module.hot.accept("./BalanceTransDetails.vue?vue&type=template&id=7e07a8e4&scoped=true", function () {
      api.rerender('7e07a8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/financials-agent/components/Balance/BalanceTransDetails.vue"
export default component.exports